import { useEffect, useState } from "react";
import EmailTab from "./EmailTab";
import LegalTab from "./LegalTab";
import { SubTabs } from "./AdminUI";

const TABS = [
  { key: "email", label: "Transactional Email" },
  { key: "legal", label: "Legal Notices" },
];

export default function CommunicationsTab({ initialTab }) {
  const [tab, setTab] = useState(initialTab === "legal" ? "legal" : "email");
  useEffect(() => { if (initialTab) setTab(initialTab); }, [initialTab]);
  return (
    <div data-testid="admin-communications-tab">
      <SubTabs tabs={TABS} active={tab} onChange={setTab} testidPrefix="comms-tab" />
      {tab === "email" ? <EmailTab /> : <LegalTab />}
    </div>
  );
}
